<template>
  <div class="metrics-page">
    <app-view-layout
      header="Metryka"
    >
      <template #toolbarMenu>
        <AppNavigateBack
          :prev-route="prevRoute"
          class="mr-4"
        />
      </template>

      <template #content>
        <ProjectMetricsInfoCard :project="metrics" />

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <ProjectCampaignsCard :value="metrics.campaigns" />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <ProjectTagsCard :value="metrics.tags" />
          </v-col>
        </v-row>

        <v-row v-if="metrics.thirdPartyWorksCard !== null">
          <v-col cols="12">
            <ProjectThirdPartyWorksCard :editable="metrics.editable" />
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="metrics.history">
            <ProjectChangesListCard
              :history="metrics.history"
            />
          </v-col>

          <v-col
            v-if="metrics.members !== null"
            cols="12"
            md="6"
            lg="4"
          >
            <ProjectTeamCard
              :users="metrics.members"
              title="Zespół projektowy"
            />
          </v-col>

          <v-col
            v-if="metrics.orderers !== null"
            cols="12"
            md="6"
            lg="4"
          >
            <ProjectTeamCard
              :users="metrics.orderers"
              title="Zespół zlecający"
              empty-state-text="Oczekiwanie na dodanie członków zespołu zlecającego."
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-text-card
              v-if="metrics.copy !== null"
              :value="metrics.copy || ''"
              title="Tekst do wykorzystania"
              disabled
            >
              <AppEmptyState
                title="Brak tekstu"
                subtitle="Oczekiwanie na dodanie tekstu do wykorzystania."
                class="pb-16"
              />
            </app-text-card>
          </v-col>
        </v-row>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import navigateBack from '@/helpers/navigateBackMixin';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectMetricsInfoCard from '@/components/Projects/ProjectMetricsInfoCard.vue';
import ProjectTeamCard from '@/components/Projects/ProjectTeamCard.vue';
import ProjectChangesListCard from '@/components/Projects/Changes/ProjectChangesListCard.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import ProjectThirdPartyWorksCard from '@/components/Projects/ProjectThirdPartyWorksCard.vue';
import ProjectTagsCard from '@/components/Projects/ProjectTagsCard.vue';
import ProjectCampaignsCard from '@/components/Projects/ProjectCampaignsCard.vue';
import AppNavigateBack from '@/components/UI/AppNavigateBack.vue';
import AppEmptyState from '@/components/UI/AppEmptyState.vue';

export default {
  components: {
    AppViewLayout,
    ProjectMetricsInfoCard,
    ProjectTeamCard,
    ProjectChangesListCard,
    AppTextCard,
    ProjectThirdPartyWorksCard,
    ProjectTagsCard,
    ProjectCampaignsCard,
    AppNavigateBack,
    AppEmptyState,
  },

  mixins: [navigateBack],

  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  computed: {
    ...mapState('metrics', [
      'metrics',
    ]),
  },

  created() {
    this.fetchMetrics(this.id);
  },

  beforeDestroy() {
    this.clearMetricsObject();
  },

  methods: {
    ...mapActions('metrics', [
      'fetchMetrics',
      'clearMetricsObject',
    ]),
  },
};
</script>
